module.exports = __webpack_public_path__ + "static/media/2 7 Ordkjedetest-Starter-testen.2b4aebf8.mp3";